import React from 'react';

function ContactArea() {

  return (
	<section className="contact-area pt-120 pb-120"   >
        <div className="container">
          <div className="row">
             <div className="col-lg-12">
             <div className="section-title title-style-three mb-20 pt-20 pb-20">
                <h3> <span>Firma Zlokalizowana jest w Olsztynie</span></h3>
              </div>
              {/* <div class="col-lg-6">
                            <div id="contact-map">
                                <iframe class="responsive-iframe" src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d75443.76216337459!2d20.39771945342511!3d53.77849519328706!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x46e2792d071419c7%3A0x106a8126cf54c20f!2solsztyn!3m2!1d53.778422!2d20.4801192!5e0!3m2!1spl!2spl!4v1726813114258!5m2!1spl!2spl" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div> */}
                               
            </div> 

            <div className="col-lg-12 pl-45 pt-80">
              
              <div className="section-title title-style-three mb-20">
                <h2>NAPISZ DO NAS <span> LUB ZADZWOŃ</span></h2>
              </div>
              <div className="contact-info-list mb-40">
                <ul>
                  <li><i className="fas fa-map-marker-alt" />Adres: GPSINSTALL Olsztyn</li>
                  {/* <li><i className="fas fa-info" />NIP: 7394000757</li> */}
                  <li><i className="fas fa-envelope" />Email: zlecenia&#64;gpsinstall&#46;eu</li>
                  <li><i className="fas fa-phone" />NR TEL: +48 515 564 637 DANIEL SKULIMOWSKI </li>
              
                </ul>
              </div>
              {/* <div className="contact-form">
                <form>
                <div className="row">
                    <div className="col-md-6">
                      <input type="text" placeholder="Twoje Imię" />
                    </div>
                    <div className="col-md-6">
                      <input type="email" placeholder="Twój Email" />
                    </div>
                  </div>
                  <textarea name="message" id="message" placeholder="Treść wiadomości..." defaultValue={""} />

                  <button>WYŚLIJ WIADOMOŚĆ</button>
                </form>
              </div> */}
            </div>
          </div>
        </div>


      </section>
  )
}

export default ContactArea



